import React from "react";
import { Image, ScrollView, Text, TouchableOpacity, View } from "react-native";
import { MaterialIcons } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/core";

import HeaderDefault from "../../components/HeaderDefault";

import { styles } from "./styles";

const DepositMethod = () => {
  const navigation = useNavigation();

  return (
    <View>
      <HeaderDefault title={"Depositar"} />

      <ScrollView style={styles.container}>
        <TouchableOpacity
          onPress={() => navigation.navigate("DepositGPXAmount")}
          style={styles.listItem}
        >
          <Image
            style={[styles.icon, { tintColor: "#1FBFB5" }]}
            source={require("../../../assets/imgs/currentBrl.png")}
          />
          <View style={styles.itemTextSection}>
            <Text style={styles.textBold}>Depositar BRL (Real Brasileiro)</Text>
            <Text>
              Na plataforma, o BRL depositado será convertido para GPX
            </Text>
          </View>
          <MaterialIcons
            name="keyboard-arrow-right"
            size={24}
            color="#2C2C2E"
            style={styles.iconGo}
            onPress={() => { }}
          />
        </TouchableOpacity>
        <TouchableOpacity
          onPress={() => navigation.navigate("DepositCryptoSelection")}
          style={styles.listItem}
        >
          <Image
            style={[styles.icon, { tintColor: "#1FBFB5" }]}
            source={require("../../../assets/imgs/blockchain.png")}
          />
          <View style={styles.itemTextSection}>
            <Text style={styles.textBold}>Depositar Criptoativos</Text>
            <Text>Deposite criptoativos.</Text>
          </View>
          <MaterialIcons
            name="keyboard-arrow-right"
            size={24}
            color="#2C2C2E"
            style={styles.iconGo}
            onPress={() => { }}
          />
        </TouchableOpacity>
        <TouchableOpacity
          onPress={() => navigation.navigate("PaperWalletDeposit")}
          style={styles.listItem}
        >
          <Image
            style={[styles.icon, { tintColor: "#1FBFB5", resizeMode: 'contain' }]}
            source={require("../../../assets/imgs/file.png")}
          />
          <View style={styles.itemTextSection}>
            <Text style={styles.textBold}>Depositar Paper Wallet</Text>
            <Text>Deposite uma Paper Wallet.</Text>
          </View>
          <MaterialIcons
            name="keyboard-arrow-right"
            size={24}
            color="#2C2C2E"
            style={styles.iconGo}
            onPress={() => { }}
          />
        </TouchableOpacity>

      </ScrollView>
    </View>
  );
};

export default DepositMethod;
